export const EXPERT_ANSWERS_TYPES = {
  General: 'General',
  Tailored: 'Tailored'
};

export const ELEMENT_TYPE = {
  PARAGRAPH: 'paragraph',
  HEADING: 'heading',
  // UL: 'unordered-list',
  // UL_2: 'unordered-list-2',
  HR: 'horizontal-rule',
  HEADER_1: 'header-1',
  HEADER_2: 'header-2',
  SPACE: 'space',
  // REFERENCE_PARAGRAPH: 'reference-paragraph',
  // POLL: 'poll',
  // DOCUMENT_CARD: 'document-card',
  DATA_TABLE: 'data-table',
  NORMAL_TABLE: 'normal-table',
  // NOTES: 'notes',
  // REFERENCE_TABLE_CELL: 'reference-table-cell',
  URL_1: 'url-1'
  // INFO: 'info'
};

export const EXPERT_ANSWERS_STATUSES = {
  Draft: 'Draft',
  Approved: 'Approved',
  Published: 'Published',
  Inactive: 'Inactive'
};
